import { Zeeguu_API } from "./classDef";
import qs from "qs";

// **********
// GET VIDEO INFO
// **********
Zeeguu_API.prototype.getVideoInfo = function (videoID, callback) {
  this._getJSON(`user_video?video_id=${videoID}`, callback);
};

// **********
// UPDATE PLAYBACK POSITION
// **********
Zeeguu_API.prototype.updatePlaybackPosition = function (videoID, positionInSeconds) {
  const onSuccess = () => {
    console.log("Playback position updated");
  };

  const onError = (error) => {
    console.error(error);
  };

  const body = {
    video_id: videoID,
    playback_position: positionInSeconds ? Math.round(positionInSeconds * 1000) : 0,
  };

  this._post(`video_set_playback`, qs.stringify(body), onSuccess, onError);
};

Zeeguu_API.prototype.setVideoOpened = function (videoID) {
  this._post("video_opened", `video_id=${videoID}`);
};

// **********
// SHARE-TO-VIDEO: client-side ingestion
// Captions are extracted in the user's browser (residential IP) because YouTube
// blocks server-side caption fetches from datacenter IPs.
// **********
Zeeguu_API.prototype.createVideoUpload = function (payload, callback, onError) {
  this._postJSON("video_upload/create", payload, callback, onError);
};